import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    auth: {
      registration: {
        header: 'HEADER',
        submit_btn: 'SUBMIT_BTN',
        attention_first_part: 'ATTENTION_FIRST_PART',
        form: {
          name: 'FORM.NAME',
          surname: 'FORM.SURNAME',
          username: 'FORM.USERNAME',
          email: 'FORM.EMAIL',
          password: 'FORM.PASSWORD',
          phone_number: 'FORM.PHONE_NUMBER',
          ms_teams: 'FORM.MS_TEAMS',
          telegram: 'FORM.TELEGRAM',
          whatsapp: 'FORM.WHATSAPP',
          birthday: 'FORM.BIRTHDAY',
          site_url: 'FORM.SITE_URL',
          about_affiliate: 'FORM.ABOUT_AFFILIATE',
          agree_receive_emails: 'FORM.AGREE_RECEIVE_EMAILS',
          language_of_communication: 'FORM.LANGUAGE_OF_COMMUNICATION',
        },
        confirmation: {
          header: 'CONFIRMATION.HEADER',
          hint: 'CONFIRMATION.HINT',
          token: 'CONFIRMATION.TOKEN',
          confirm_email: 'CONFIRMATION.CONFIRM_EMAIL',
          next: 'CONFIRMATION.NEXT',
        },
        done: {
          header: 'DONE.HEADER',
          description: 'DONE.DESCRIPTION',
          finish: 'DONE.FINISH',
        },
      },
    },
  }));
}
